<p-floatLabel class="prime-float-label" [ngClass]="classes()">
  <ng-content></ng-content>
  <label [attr.for]="inputId()">
    {{label()}}
  </label>
</p-floatLabel>
